// source: shape_proto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var coordinate_proto_pb = require('./coordinate_proto_pb.js');
goog.object.extend(proto, coordinate_proto_pb);
var location_proto_pb = require('./location_proto_pb.js');
goog.object.extend(proto, location_proto_pb);
goog.exportSymbol('proto.Geofence', null, global);
goog.exportSymbol('proto.Geofence.NotificationStrategy', null, global);
goog.exportSymbol('proto.Geofence.NotificationTarget', null, global);
goog.exportSymbol('proto.GeofenceTraversal', null, global);
goog.exportSymbol('proto.GeofenceTraversal.Direction', null, global);
goog.exportSymbol('proto.Shape', null, global);
goog.exportSymbol('proto.Shape.Circle', null, global);
goog.exportSymbol('proto.Shape.Polygon', null, global);
goog.exportSymbol('proto.Shape.Polygon.Type', null, global);
goog.exportSymbol('proto.Shape.ShapeCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Shape = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.Shape.oneofGroups_);
};
goog.inherits(proto.Shape, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Shape.displayName = 'proto.Shape';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Shape.Circle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Shape.Circle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Shape.Circle.displayName = 'proto.Shape.Circle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Shape.Polygon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Shape.Polygon.repeatedFields_, null);
};
goog.inherits(proto.Shape.Polygon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Shape.Polygon.displayName = 'proto.Shape.Polygon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Geofence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Geofence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Geofence.displayName = 'proto.Geofence';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GeofenceTraversal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GeofenceTraversal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GeofenceTraversal.displayName = 'proto.GeofenceTraversal';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Shape.oneofGroups_ = [[6,7]];

/**
 * @enum {number}
 */
proto.Shape.ShapeCase = {
  SHAPE_NOT_SET: 0,
  CIRCLE: 6,
  POLYGON: 7
};

/**
 * @return {proto.Shape.ShapeCase}
 */
proto.Shape.prototype.getShapeCase = function() {
  return /** @type {proto.Shape.ShapeCase} */(jspb.Message.computeOneofCase(this, proto.Shape.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Shape.prototype.toObject = function(opt_includeInstance) {
  return proto.Shape.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Shape} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Shape.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
notes: jspb.Message.getFieldWithDefault(msg, 3, ""),
geofence: (f = msg.getGeofence()) && proto.Geofence.toObject(includeInstance, f),
workspaceId: jspb.Message.getFieldWithDefault(msg, 5, ""),
circle: (f = msg.getCircle()) && proto.Shape.Circle.toObject(includeInstance, f),
polygon: (f = msg.getPolygon()) && proto.Shape.Polygon.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Shape}
 */
proto.Shape.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Shape;
  return proto.Shape.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Shape} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Shape}
 */
proto.Shape.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 4:
      var value = new proto.Geofence;
      reader.readMessage(value,proto.Geofence.deserializeBinaryFromReader);
      msg.setGeofence(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    case 6:
      var value = new proto.Shape.Circle;
      reader.readMessage(value,proto.Shape.Circle.deserializeBinaryFromReader);
      msg.setCircle(value);
      break;
    case 7:
      var value = new proto.Shape.Polygon;
      reader.readMessage(value,proto.Shape.Polygon.deserializeBinaryFromReader);
      msg.setPolygon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Shape.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Shape.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Shape} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Shape.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGeofence();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.Geofence.serializeBinaryToWriter
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCircle();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.Shape.Circle.serializeBinaryToWriter
    );
  }
  f = message.getPolygon();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.Shape.Polygon.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Shape.Circle.prototype.toObject = function(opt_includeInstance) {
  return proto.Shape.Circle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Shape.Circle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Shape.Circle.toObject = function(includeInstance, msg) {
  var f, obj = {
center: (f = msg.getCenter()) && coordinate_proto_pb.CoordinateDto.toObject(includeInstance, f),
radius: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Shape.Circle}
 */
proto.Shape.Circle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Shape.Circle;
  return proto.Shape.Circle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Shape.Circle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Shape.Circle}
 */
proto.Shape.Circle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new coordinate_proto_pb.CoordinateDto;
      reader.readMessage(value,coordinate_proto_pb.CoordinateDto.deserializeBinaryFromReader);
      msg.setCenter(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRadius(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Shape.Circle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Shape.Circle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Shape.Circle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Shape.Circle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCenter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      coordinate_proto_pb.CoordinateDto.serializeBinaryToWriter
    );
  }
  f = message.getRadius();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional CoordinateDto center = 1;
 * @return {?proto.CoordinateDto}
 */
proto.Shape.Circle.prototype.getCenter = function() {
  return /** @type{?proto.CoordinateDto} */ (
    jspb.Message.getWrapperField(this, coordinate_proto_pb.CoordinateDto, 1));
};


/**
 * @param {?proto.CoordinateDto|undefined} value
 * @return {!proto.Shape.Circle} returns this
*/
proto.Shape.Circle.prototype.setCenter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Shape.Circle} returns this
 */
proto.Shape.Circle.prototype.clearCenter = function() {
  return this.setCenter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Shape.Circle.prototype.hasCenter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 radius = 2;
 * @return {number}
 */
proto.Shape.Circle.prototype.getRadius = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Shape.Circle} returns this
 */
proto.Shape.Circle.prototype.setRadius = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Shape.Polygon.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Shape.Polygon.prototype.toObject = function(opt_includeInstance) {
  return proto.Shape.Polygon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Shape.Polygon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Shape.Polygon.toObject = function(includeInstance, msg) {
  var f, obj = {
perimeterList: jspb.Message.toObjectList(msg.getPerimeterList(),
    coordinate_proto_pb.CoordinateDto.toObject, includeInstance),
type: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Shape.Polygon}
 */
proto.Shape.Polygon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Shape.Polygon;
  return proto.Shape.Polygon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Shape.Polygon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Shape.Polygon}
 */
proto.Shape.Polygon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new coordinate_proto_pb.CoordinateDto;
      reader.readMessage(value,coordinate_proto_pb.CoordinateDto.deserializeBinaryFromReader);
      msg.addPerimeter(value);
      break;
    case 2:
      var value = /** @type {!proto.Shape.Polygon.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Shape.Polygon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Shape.Polygon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Shape.Polygon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Shape.Polygon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPerimeterList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      coordinate_proto_pb.CoordinateDto.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.Shape.Polygon.Type = {
  UNKNOWN: 0,
  RECTANGLE: 1,
  FREEFORM: 2
};

/**
 * repeated CoordinateDto perimeter = 1;
 * @return {!Array<!proto.CoordinateDto>}
 */
proto.Shape.Polygon.prototype.getPerimeterList = function() {
  return /** @type{!Array<!proto.CoordinateDto>} */ (
    jspb.Message.getRepeatedWrapperField(this, coordinate_proto_pb.CoordinateDto, 1));
};


/**
 * @param {!Array<!proto.CoordinateDto>} value
 * @return {!proto.Shape.Polygon} returns this
*/
proto.Shape.Polygon.prototype.setPerimeterList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.CoordinateDto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.CoordinateDto}
 */
proto.Shape.Polygon.prototype.addPerimeter = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.CoordinateDto, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Shape.Polygon} returns this
 */
proto.Shape.Polygon.prototype.clearPerimeterList = function() {
  return this.setPerimeterList([]);
};


/**
 * optional Type type = 2;
 * @return {!proto.Shape.Polygon.Type}
 */
proto.Shape.Polygon.prototype.getType = function() {
  return /** @type {!proto.Shape.Polygon.Type} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Shape.Polygon.Type} value
 * @return {!proto.Shape.Polygon} returns this
 */
proto.Shape.Polygon.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.Shape.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Shape} returns this
 */
proto.Shape.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.Shape.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Shape} returns this
 */
proto.Shape.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string notes = 3;
 * @return {string}
 */
proto.Shape.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Shape} returns this
 */
proto.Shape.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Geofence geofence = 4;
 * @return {?proto.Geofence}
 */
proto.Shape.prototype.getGeofence = function() {
  return /** @type{?proto.Geofence} */ (
    jspb.Message.getWrapperField(this, proto.Geofence, 4));
};


/**
 * @param {?proto.Geofence|undefined} value
 * @return {!proto.Shape} returns this
*/
proto.Shape.prototype.setGeofence = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Shape} returns this
 */
proto.Shape.prototype.clearGeofence = function() {
  return this.setGeofence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Shape.prototype.hasGeofence = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string workspace_id = 5;
 * @return {string}
 */
proto.Shape.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Shape} returns this
 */
proto.Shape.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Circle circle = 6;
 * @return {?proto.Shape.Circle}
 */
proto.Shape.prototype.getCircle = function() {
  return /** @type{?proto.Shape.Circle} */ (
    jspb.Message.getWrapperField(this, proto.Shape.Circle, 6));
};


/**
 * @param {?proto.Shape.Circle|undefined} value
 * @return {!proto.Shape} returns this
*/
proto.Shape.prototype.setCircle = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.Shape.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Shape} returns this
 */
proto.Shape.prototype.clearCircle = function() {
  return this.setCircle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Shape.prototype.hasCircle = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Polygon polygon = 7;
 * @return {?proto.Shape.Polygon}
 */
proto.Shape.prototype.getPolygon = function() {
  return /** @type{?proto.Shape.Polygon} */ (
    jspb.Message.getWrapperField(this, proto.Shape.Polygon, 7));
};


/**
 * @param {?proto.Shape.Polygon|undefined} value
 * @return {!proto.Shape} returns this
*/
proto.Shape.prototype.setPolygon = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.Shape.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Shape} returns this
 */
proto.Shape.prototype.clearPolygon = function() {
  return this.setPolygon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Shape.prototype.hasPolygon = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Geofence.prototype.toObject = function(opt_includeInstance) {
  return proto.Geofence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Geofence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Geofence.toObject = function(includeInstance, msg) {
  var f, obj = {
notificationTarget: jspb.Message.getFieldWithDefault(msg, 1, 0),
notificationStrategy: jspb.Message.getFieldWithDefault(msg, 2, 0),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Geofence}
 */
proto.Geofence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Geofence;
  return proto.Geofence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Geofence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Geofence}
 */
proto.Geofence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Geofence.NotificationTarget} */ (reader.readEnum());
      msg.setNotificationTarget(value);
      break;
    case 2:
      var value = /** @type {!proto.Geofence.NotificationStrategy} */ (reader.readEnum());
      msg.setNotificationStrategy(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Geofence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Geofence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Geofence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Geofence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotificationTarget();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getNotificationStrategy();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.Geofence.NotificationTarget = {
  UNKNOWN: 0,
  WORKSPACEADMIN: 1
};

/**
 * @enum {number}
 */
proto.Geofence.NotificationStrategy = {
  NONE: 0,
  ENTRANCE: 1,
  EXIT: 2,
  ENTRANCEANDEXIT: 3
};

/**
 * optional NotificationTarget notification_target = 1;
 * @return {!proto.Geofence.NotificationTarget}
 */
proto.Geofence.prototype.getNotificationTarget = function() {
  return /** @type {!proto.Geofence.NotificationTarget} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Geofence.NotificationTarget} value
 * @return {!proto.Geofence} returns this
 */
proto.Geofence.prototype.setNotificationTarget = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional NotificationStrategy notification_strategy = 2;
 * @return {!proto.Geofence.NotificationStrategy}
 */
proto.Geofence.prototype.getNotificationStrategy = function() {
  return /** @type {!proto.Geofence.NotificationStrategy} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Geofence.NotificationStrategy} value
 * @return {!proto.Geofence} returns this
 */
proto.Geofence.prototype.setNotificationStrategy = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional bool enabled = 3;
 * @return {boolean}
 */
proto.Geofence.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Geofence} returns this
 */
proto.Geofence.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GeofenceTraversal.prototype.toObject = function(opt_includeInstance) {
  return proto.GeofenceTraversal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GeofenceTraversal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GeofenceTraversal.toObject = function(includeInstance, msg) {
  var f, obj = {
shapeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
traversalLocation: (f = msg.getTraversalLocation()) && location_proto_pb.LocationResponse.toObject(includeInstance, f),
direction: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GeofenceTraversal}
 */
proto.GeofenceTraversal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GeofenceTraversal;
  return proto.GeofenceTraversal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GeofenceTraversal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GeofenceTraversal}
 */
proto.GeofenceTraversal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setShapeId(value);
      break;
    case 2:
      var value = new location_proto_pb.LocationResponse;
      reader.readMessage(value,location_proto_pb.LocationResponse.deserializeBinaryFromReader);
      msg.setTraversalLocation(value);
      break;
    case 3:
      var value = /** @type {!proto.GeofenceTraversal.Direction} */ (reader.readEnum());
      msg.setDirection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GeofenceTraversal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GeofenceTraversal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GeofenceTraversal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GeofenceTraversal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShapeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTraversalLocation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      location_proto_pb.LocationResponse.serializeBinaryToWriter
    );
  }
  f = message.getDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.GeofenceTraversal.Direction = {
  UNKNOWN: 0,
  ENTERING: 1,
  EXITING: 2
};

/**
 * optional string shape_id = 1;
 * @return {string}
 */
proto.GeofenceTraversal.prototype.getShapeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeofenceTraversal} returns this
 */
proto.GeofenceTraversal.prototype.setShapeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LocationResponse traversal_location = 2;
 * @return {?proto.LocationResponse}
 */
proto.GeofenceTraversal.prototype.getTraversalLocation = function() {
  return /** @type{?proto.LocationResponse} */ (
    jspb.Message.getWrapperField(this, location_proto_pb.LocationResponse, 2));
};


/**
 * @param {?proto.LocationResponse|undefined} value
 * @return {!proto.GeofenceTraversal} returns this
*/
proto.GeofenceTraversal.prototype.setTraversalLocation = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GeofenceTraversal} returns this
 */
proto.GeofenceTraversal.prototype.clearTraversalLocation = function() {
  return this.setTraversalLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GeofenceTraversal.prototype.hasTraversalLocation = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Direction direction = 3;
 * @return {!proto.GeofenceTraversal.Direction}
 */
proto.GeofenceTraversal.prototype.getDirection = function() {
  return /** @type {!proto.GeofenceTraversal.Direction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.GeofenceTraversal.Direction} value
 * @return {!proto.GeofenceTraversal} returns this
 */
proto.GeofenceTraversal.prototype.setDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


goog.object.extend(exports, proto);
